<p-dialog #editingDialog
          *ngIf="gridDataEditor.dialogRequired"
          [(visible)]="gridDataEditor.editingDialogVisible"
          [modal]="true"
          [draggable]="false"
          [style]="{'max-width': '600px', width: '100%'}"
          [header]="gridDataEditor.creationState ? 'Create' : 'Edit'"
          appendTo="body"
          class="editing-dialog"
          (onHide)="onEditingDialogHide()" rte="1i0">
    <form *ngIf="gridDataEditor.formGroup" [formGroup]="gridDataEditor.formGroup" class="inputs-group" rte="1i1">
        <ng-container *ngFor="let column of gridDataEditor.columns">
            <div *ngIf="gridDataEditor.isEditableColumn(column)" class="inputs-group-row" rte="1i2">
                <label [ngClass]="{'asterisk-mark': gridDataEditor.isRequiredColumn(column), 'inputs-group-row-name': true, 'capitalized-label': !column.label}" rte="1i3">
                    {{column.label ? column.label : column.header}}
                </label>
                <div [ngSwitch]="column.cellEditingInputType" class="inputs-group-row-value" rte="1i4">
                    <p-inputNumber *ngSwitchCase="_cellEditingInputTypeEnum.Number"
                                   [formControlName]="column.field"
                                   [showButtons]="true"
                                   [step]="column.numericInputStep ? column.numericInputStep : 1"
                                   [max]="column.numericInputMax"
                                   [min]="column.numericInputMin"
                                   [maxFractionDigits]="column.numericInputMaxFractionDigits"
                                   mode="decimal"
                                   locale="en-US"
                                   [placeholder]="column.placeholder ? column.placeholder : ''"
                                   [disabled]="column.disabledFunc && column.disabledFunc(gridDataEditor.editableRow, gridDataEditor.formGroup.value)" rte="1i5">
                    </p-inputNumber>
                    <p-calendar *ngSwitchCase="_cellEditingInputTypeEnum.Calendar"
                                [formControlName]="column.field"
                                [dateFormat]="column.calendarDateFormat ? column.calendarDateFormat : null"
                                [showIcon]="true"
                                [showButtonBar]="true"
                                [showTime]="column.calendarShowTime"
                                [hourFormat]="column.calendarHourFormat ? column.calendarHourFormat : '12'"
                                [readonlyInput]="true"
                                [yearNavigator]="true"
                                [yearRange]="column.calendarYearRange ? column.calendarYearRange : gridDataEditor.defaultCalendarYearRange"
                                [monthNavigator]="true"
                                [placeholder]="column.placeholder ? column.placeholder : ''"
                                [appendTo]="editingDialog"
                                [disabled]="column.disabledFunc && column.disabledFunc(gridDataEditor.editableRow, gridDataEditor.formGroup.value)" rte="1i6">
                    </p-calendar>
                    <p-checkbox *ngSwitchCase="_cellEditingInputTypeEnum.Checkbox"
                                [formControlName]="column.field"
                                [binary]="true"
                                [disabled]="column.disabledFunc && column.disabledFunc(gridDataEditor.editableRow, gridDataEditor.formGroup.value)" rte="1i7">
                    </p-checkbox>
                    <p-dropdown *ngSwitchCase="_cellEditingInputTypeEnum.Dropdown"
                                [formControlName]="column.field"
                                [options]="gridDataEditor.getDropDownOptions(column, gridDataEditor.editableRow)"
                                [dataKey]="column.dropdownOptionsDataKey"
                                [filter]="column.dropdownFilterEnabled"
                                [filterBy]="column.dropdownFilterBy"
                                [appendTo]="editingDialog"
                                [placeholder]="column.placeholder ? column.placeholder : ''"
                                [disabled]="column.disabledFunc && column.disabledFunc(gridDataEditor.editableRow, gridDataEditor.formGroup.value)" rte="1i8">
                    </p-dropdown>
                    <p-multiSelect *ngSwitchCase="_cellEditingInputTypeEnum.Multiselect"
                                   [formControlName]="column.field"
                                   [options]="gridDataEditor.getDropDownOptions(column, gridDataEditor.editableRow)"
                                   [dataKey]="column.dropdownOptionsDataKey"
                                   [defaultLabel]="column.placeholder ? column.placeholder : ''"
                                   [filter]="column.dropdownFilterEnabled"
                                   [filterBy]="column.dropdownFilterBy"
                                   [appendTo]="editingDialog"
                                   [disabled]="column.disabledFunc && column.disabledFunc(gridDataEditor.editableRow, gridDataEditor.formGroup.value)" rte="1i9">
                    </p-multiSelect>
                    <textarea *ngSwitchCase="_cellEditingInputTypeEnum.Textarea"
                              pInputTextarea
                              [formControlName]="column.field"
                              [placeholder]="column.placeholder ? column.placeholder : ''"
                              [disabled]="column.disabledFunc && column.disabledFunc(gridDataEditor.editableRow, gridDataEditor.formGroup.value)" rte="1ia">
                    </textarea>
                    <input *ngSwitchDefault
                           pInputText
                           [formControlName]="column.field"
                           [placeholder]="column.placeholder ? column.placeholder : ''"
                           [disabled]="column.disabledFunc && column.disabledFunc(gridDataEditor.editableRow, gridDataEditor.formGroup.value)" rte="1ib"/>

                    <ng-container *ngIf="gridDataEditor.formGroup.controls[column.field].dirty && gridDataEditor.formGroup.controls[column.field].errors">
                        <span *ngFor="let error of gridDataEditor.getErrorMessagesForControl(column, gridDataEditor.formGroup.controls[column.field])" class="validation-error" rte="1ic">
                            {{error}}
                        </span>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </form>

    <p-footer rte="1id">
        <ng-container *ngIf="gridDataEditor.formGroup">
            <button pButton
                    [label]="gridDataEditor.cancelButtonText"
                    icon="pi pi-times"
                    class="p-button-secondary"
                    (click)="onEditingDialogCancelButtonClick()" rte="1ie">
            </button>
            <button pButton
                    [label]="gridDataEditor.saveButtonText"
                    icon="pi pi-check"
                    [disabled]="gridDataEditor.formGroup.invalid || gridDataEditor.pending"
                    (click)="onEditingDialogSaveButtonClick()" rte="1if">
            </button>
        </ng-container>
    </p-footer>
</p-dialog>